module.exports = __webpack_public_path__ + "static/media/21ECLAC10.ab6b73c7.jpg";